import React, { Component } from 'react'
import styled, { ThemeProvider } from 'styled-components'
import Container from 'reactstrap/lib/Container'
import themes from '../../themes'

const CenterContent = styled(Container)`
  background-color: #fff;
  max-width: 1080px;
  padding: 0 8px;
  position: relative;

  @-ms-viewport { 
    width: device-width; 
  }
`

export default class Main extends Component {
  render () {
    const {
      children,
      className,
      layout
    } = this.props

    return (
      <ThemeProvider theme={themes[layout]}>
        <CenterContent fluid={true} className={className}>
          { children }
        </CenterContent>
      </ThemeProvider>
    )
  }
}
